/** * 分包工具-广点通*/
import request from '@/utils/request';
import Resource from '@/api/resource';

class ExtendPackageResource extends Resource {
  constructor() {
    super('tool/extendPackage/gdt');
  }

  /** 获取应用分包列表接口 */
  getExtendPackageListApi(params) {
    return request({
      url: `/${this.uri}`,
      method: 'get',
      params,
    });
  }

  /** 创建应用分包接口 */
  createExtendPackageApi(data) {
    return request({
      url: `/${this.uri}`,
      method: 'post',
      data,
    });
  }

  /** 更新应用分包接口 */
  batchUpdateExtendPackageApi(data) {
    return request({
      url: `/${this.uri}/batchUpdate`,
      method: 'post',
      data,
    });
  }

  /** 同步应用分包接口 */
  pullExtendPackageApi(params) {
    return request({
      url: `/${this.uri}/pull`,
      method: 'get',
      params,
    });
  }
}
export { ExtendPackageResource as default };
